<template>
  <div class="search-form padding_large">
    <form @submit.prevent="doSearch">
      <div class="input-holder">
        <StyledIcon iconsColor="#fff" class="icon" v-html="svgIcons.loupe" />
        <input
          name="search"
          v-model="inputValue"
          :placeholder="placeholder"
          class="input-with-icon"
          type="text"
        />
      </div>
    </form>
  </div>
</template>

<script>
import StyledIcon from "@/components/elements/StyledIcon";

export default {
  name: "search-form",
  props: ["placeholder"],
  data() {
    const VM = this;
    return {
      inputValue: VM.$route.query.search ? VM.$route.query.search : ""
    };
  },
  watch: {
    inputValue(val) {
      this.$emit("changed", val);
    }
  },
  computed: {},
  components: {
    StyledIcon
  },
  mounted() {
    if (this.inputValue) {
      this.$emit("changed", this.inputValue);
    }
  },
  methods: {
    doSearch(e) {
      this.$emit("submit", this.inputValue);
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.search-form {
  background-color: $purple;
  .input-holder {
    position: relative;
    .icon {
      position: absolute;
      top: 50%;
      margin-top: 2px;
      transform: translateY(-50%);
      left: 10px;
    }
    .input-with-icon {
      border: 2px solid #fff;
      color: #fff;
      background-color: $purple;
      box-shadow: none;
      width: 100%;
      font-size: 16px;
      padding: 8px 35px;
      &::placeholder {
        color: #fff;
      }
    }
  }
}
</style>
